<template>
  <div>
    <el-button-group>
      <el-button :class="{ active: type === 1 }" type="primary" plain @click="getAutoTemperature(1)"
        >7天</el-button
      >
      <el-button :class="{ active: type === 2 }" type="primary" plain @click="getAutoTemperature(2)"
        >30天</el-button
      >
    </el-button-group>
    <div class="clearfix"></div>
    <div class="autoTemperature" ref="autoTemperatureChart"></div>
  </div>
</template>

<script>
let echarts = require('echarts')

export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    room: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      type: 1
    }
  },
  mounted() {
    // 获取实时温度数据
    this.$nextTick(() => {
      this.getAutoTemperature(this.type)
    })
  },
  methods: {
    getAutoTemperature(type) {
      this.type = type

      let params = {
        id: this.id,
        type: type
      }
      this.$ajax.get(this.$api.freezer.device_tempMonitor, params).then((res) => {
        let autoTemperatureChart = echarts.init(this.$refs.autoTemperatureChart)
        autoTemperatureChart.clear()
        // 图表自适应
        window.onresize = autoTemperatureChart.resize

        // 判断间室
        let series = []
        if (this.room == 1) {
          series = [
            {
              name: '间室温度',
              type: 'line',
              stack: 'Total',
              smooth: true,
              data: res.data.line.yAxis[0].arr.reverse(),
              itemStyle: {
                normal: {
                  color: '#539CFF'
                }
              }
            }
          ]
        } else if (this.room == 2) {
          series = [
            {
              name: '间室1温度',
              type: 'line',
              stack: 'Total',
              smooth: true,
              data: res.data.line.yAxis[0].arr.reverse(),
              itemStyle: {
                normal: {
                  color: '#539CFF'
                }
              }
            },
            {
              name: '间室2温度',
              type: 'line',
              stack: 'Total',
              smooth: true,
              data: res.data.line.yAxis[1].arr.reverse(),
              itemStyle: {
                normal: {
                  color: '#67D0FA'
                }
              }
            }
          ]
        }

        autoTemperatureChart.setOption({
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: res.data.line.xAxis.reverse(),
            axisLabel: {
              textStyle: {
                fontSize: 12,
                color: '#666666'
              }
            },
            axisLine: {
              lineStyle: {
                color: '#DADEE7'
              }
            },
            axisTick: {
              show: false
            }
          },
          yAxis: {
            type: 'value',
            name: '单位：℃',
            axisLabel: {
              textStyle: {
                fontSize: 12,
                color: '#666666'
              }
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            interval: 10,
            min: -140,
            max: 60
          },
          grid: {
            left: 20,
            right: 0,
            top: '30px',
            bottom: 0,
            height: '84%',
            width: '94%',
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'line',
              lineStyle: {
                type: 'dashed',
                color: '#BEC2CE'
              }
            }
          },
          series: series,
          dataZoom: {
            type: 'inside'
          }
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.el-button-group {
  float: right;
  .el-button {
    background: #ffffff;
    border-color: #dcdcdc;
    color: #666666;
    &:hover {
      background: #005aab;
      border-color: #005aab;
      color: #ffffff;
    }
    &.active {
      background: #005aab;
      border-color: #005aab;
      color: #ffffff;
    }
  }
}
.autoTemperature {
  margin-top: 40px;
  width: 100%;
  height: 420px;
}
</style>
